import { UseFormReturn } from 'react-hook-form'
import { z } from 'zod'

import { InstrumentDto } from '@/gen/publicApi'

import FormSelect from '@/components/form/formSelect'

// eslint-disable-next-line react-refresh/only-export-components
export const instrumentSymbolSchema = z.object({
    instrumentSymbol: z.string(),
})
type InstrumentSymbolSchemaType = z.infer<typeof instrumentSymbolSchema>

interface Props {
    instrumentData?: InstrumentDto[]
    form: UseFormReturn<InstrumentSymbolSchemaType>
    disabled?: boolean
}

export default function CreateOrderInstrumentSymbolForm({ instrumentData, form, disabled }: Props) {
    return (
        <FormSelect
            control={form.control}
            name="instrumentSymbol"
            label="Instrument"
            placeholder="Choose the market instrument"
            options={
                // TODO - better loading state for when instruments are being fetched
                // would be nicer
                instrumentData
                    ?.sort((a, b) => a.symbol.localeCompare(b.symbol))
                    .map(i => ({
                        value: i.symbol,
                        label: `${i.symbol} - ${i.name}`,
                    })) || []
            }
            className="mt-4"
            disabled={disabled}
        />
    )
}
